import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as IconBeachPalm } from 'media/svg/beachPalm.svg';

import styles from './Item.module.scss';

interface IncentiveProps {
    onMoreClick: () => void;
}

const Incentive = ({ onMoreClick }: IncentiveProps) => {
    const { t } = useTranslation();
    return (
        <div className={styles.Teaser}>
            <IconBeachPalm />
            <div className={styles.Text}>
                <h3>{t('TRANS-recommender-incentive')}</h3>
                <div
                    className={styles.SecondLine}
                    onClick={onMoreClick}
                    dangerouslySetInnerHTML={{
                        __html: t('TRANS-recommender-show-more'),
                    }}
                    role="button"
                    tabIndex={0}
                    onKeyDown={onMoreClick}
                />
            </div>
        </div>
    );
};

export default Incentive;
